import { Rce_DxSubUnit } from '../models/stream/jobs/rce_dxsubunit';

export class Rce_DxSubUnitsUtil {

    private static instance: Rce_DxSubUnitsUtil;
    static getInstance() {
        if (!Rce_DxSubUnitsUtil.instance) {
            Rce_DxSubUnitsUtil.instance = new Rce_DxSubUnitsUtil();
        }
        return Rce_DxSubUnitsUtil.instance;
    }

    /**
     * Rce_DxSubUnitsUtil is a singleton class, so use Rce_DxSubUnitsUtil.getInstance() 
     * method instead of creating new Rce_DxSubUnitsUtil().
     */
    private constructor() {

    }



    copy(rce_DxSubUnits: Array<Rce_DxSubUnit>): Array<Rce_DxSubUnit> {

        let rce_DxSubUnitsTmp: Array<Rce_DxSubUnit> = new Array<Rce_DxSubUnit>();

        for (let i: number = 0; i < rce_DxSubUnits.length; i++) {
            let rce_DxSubUnit: Rce_DxSubUnit = rce_DxSubUnits[i] as Rce_DxSubUnit;
            rce_DxSubUnitsTmp.push(rce_DxSubUnit.copy())
        }

        return rce_DxSubUnitsTmp;

    }

    copyFrom(rce_DxSubUnits, rce_DxSubUnitsTmp) {
        let paramsMap: Map<number, Rce_DxSubUnit> = new Map();

        for (let i: number = 0; i < rce_DxSubUnits.length; i++) {
            let rce_DxSubUnit: Rce_DxSubUnit = rce_DxSubUnits[i] as Rce_DxSubUnit;
            paramsMap.set(rce_DxSubUnit.dxSubUnit_Id, rce_DxSubUnit);
        }

        rce_DxSubUnits.splice(0, rce_DxSubUnits.length);

        for (let i: number = 0; i < rce_DxSubUnitsTmp.length; i++) {
            let rce_DxSubUnitTmp: Rce_DxSubUnit = rce_DxSubUnitsTmp[i] as Rce_DxSubUnit;

            let rce_DxSubUnit: Rce_DxSubUnit = paramsMap.get(rce_DxSubUnitTmp.dxSubUnit_Id);
            if (rce_DxSubUnit) {
                rce_DxSubUnit.copyFrom(rce_DxSubUnitTmp);
            } else {
                rce_DxSubUnit = Rce_DxSubUnit.parse(rce_DxSubUnitTmp);
            }

            rce_DxSubUnits.push(rce_DxSubUnit);
        }
    }

    toString(rce_DxSubUnits): string {
        return "";
    }
}
